import React, { useContext } from 'react'
import AppContext from '../context/appContext'
import { useNavigate } from 'react-router-dom'
import PortfolioForm from './PortfolioForm'

const PortfolioCreate = () => {
  const { createPortfolio, uploadImage } = useContext(AppContext)
  const navigate = useNavigate()

  const onSubmit = async (payload) => {
    try {
      await createPortfolio(payload)
      navigate('/dashboard/portfolio')
    } catch {}
  }

  return (
    <div style={{ backgroundColor: '#151619', minHeight: '100vh' }}>
      <div className="container py-4">
        <h2 className="text-light">Create Portfolio</h2>
        <PortfolioForm onSubmit={onSubmit} onUpload={uploadImage} />
      </div>
    </div>
  )
}

export default PortfolioCreate